!function(){
"use strict";
var STORAGE_KEY = "divarouj_wishlist_v1";

function readStore(){
  try{
    var raw = localStorage.getItem(STORAGE_KEY);
    var obj = raw ? JSON.parse(raw) : {};
    return (obj && typeof obj === "object") ? obj : {};
  }catch(e){ return {}; }
}
function writeStore(obj){
  try{ localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); }catch(e){}
}
function getIds(store){
  return Object.keys(store || {});
}

function buildWishlistUrl(store){
  var ids = getIds(store);
  if(ids.length === 0){
    return "/search?view=wishlist";
  }
  var q = ids.map(function(id){ return "id:" + id; }).join(" OR ");
  return "/search?type=product&view=wishlist&q=" + encodeURIComponent(q);
}

function setButtonState(el, active){
  if(!el) return;
  el.classList.toggle("is-active", active);
  el.classList.toggle("active", active);
  el.classList.toggle("is--added", active);
  el.setAttribute("aria-pressed", active ? "true" : "false");
}

function syncAllButtons(){
  var store = readStore();
  var nodes = document.querySelectorAll("[data-action-wishlist]");
  for(var i = 0; i < nodes.length; i++){
    var el = nodes[i];
    var id = el.getAttribute("data-id");
    if(!id) continue;
    setButtonState(el, Object.prototype.hasOwnProperty.call(store, id));
  }
}

// The cart drawer script (divarouj-cart-stable.js) keeps every cart-count
// badge in sync via a broad ".t4s-count-box" selector -- and the wishlist
// count badge in the header/mobile toolbar carries that same class for its
// pill styling, so every cart update overwrites it with the cart's item
// count instead of the wishlist count. We can't narrow that selector
// without risking the cart badges, so instead we watch our own badges with
// a MutationObserver and immediately re-assert the correct wishlist number
// whenever anything else changes their text.
var wishlistObservers = [];
var currentWishlistCount = 0;

function observeCountBadge(el){
  if(el.__divaWishObserved) return;
  el.__divaWishObserved = true;
  var obs = new MutationObserver(function(){
    var expected = String(currentWishlistCount);
    if(el.textContent !== expected){
      el.textContent = expected;
    }
  });
  obs.observe(el, { childList: true, characterData: true, subtree: true });
  wishlistObservers.push(obs);
}

function syncNavLinks(){
  var store = readStore();
  var count = getIds(store).length;
  currentWishlistCount = count;
  var url = buildWishlistUrl(store);
  var links = document.querySelectorAll("[data-link-wishlist]");
  for(var i = 0; i < links.length; i++){
    links[i].setAttribute("href", url);
  }
  var counts = document.querySelectorAll("[data-count-wishlist]");
  for(var j = 0; j < counts.length; j++){
    var span = counts[j];
    span.textContent = count;
    if(count > 0){
      span.classList.remove("t4s-op-0");
    }else{
      span.classList.add("t4s-op-0");
    }
    observeCountBadge(span);
  }
}

function refreshAll(){
  syncAllButtons();
  syncNavLinks();
}

function extractHandle(el){
  var h = el.getAttribute("data-handle");
  if(h) return h;
  var href = el.getAttribute("href") || "";
  var m = href.match(/\/products\/([^/?#]+)/);
  return m ? m[1] : "";
}

function toggle(el){
  var id = el.getAttribute("data-id");
  if(!id) return;
  var store = readStore();
  if(Object.prototype.hasOwnProperty.call(store, id)){
    delete store[id];
  }else{
    store[id] = extractHandle(el);
  }
  writeStore(store);
  refreshAll();
  try{
    document.dispatchEvent(new CustomEvent("divarouj:wishlist:change", { detail: { store: store } }));
  }catch(e){}
}

// Registered on the CAPTURE phase so this runs before any bubble-phase
// handler bound elsewhere in the theme.
document.addEventListener("click", function(e){
  var el = e.target.closest ? e.target.closest("[data-action-wishlist]") : null;
  if(!el) return;
  e.preventDefault();
  e.stopPropagation();
  if(e.stopImmediatePropagation) e.stopImmediatePropagation();
  toggle(el);
}, true);

function init(){
  refreshAll();
  // Re-assert shortly after load too, in case other deferred scripts
  // (cart count sync, etc.) run after us and stomp the badge once more.
  setTimeout(refreshAll, 300);
  setTimeout(refreshAll, 1200);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", init);
}else{
  init();
}

document.addEventListener("cart:updated", syncNavLinks);
document.addEventListener("cart:refresh", syncNavLinks);
document.addEventListener("t4s:collection:reloaded", refreshAll);
document.addEventListener("shopify:section:load", refreshAll);
}();
